import { render, staticRenderFns } from "./create-dropdown.vue?vue&type=template&id=63047d32&scoped=true&"
import script from "./create-dropdown.vue?vue&type=script&lang=js&"
export * from "./create-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./create-dropdown.vue?vue&type=style&index=0&id=63047d32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63047d32",
  null
  
)

export default component.exports